import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { BookOpen, Play } from 'lucide-react';
import { getMediaUrl } from '../utils/mediaUtils';

const DailyWord = () => {
  const videos = [
    {
      id: 1,
      title: "Faith Comes From Hearing",
      scripture: "Romans 10:17",
      description: "\"Faith comes from hearing, and hearing through the word of Christ.\" Discover how God's Word builds faith in your life and transforms your heart.",
      videoUrl: "https://customer-assets.emergentagent.com/job_faith-library-22/artifacts/ift8tjpo_FB_VID_4946684504407145478.mp4",
      thumbnail: "https://customer-assets.emergentagent.com/job_faith-library-22/artifacts/bv3b5szf_Screenshot_2026-06-24-16-53-53-48_f69139cffc4d135a71392e13634f144a.jpg"
    },
    {
      id: 2,
      title: "The Living Word of God",
      scripture: "Hebrews 4:12-13",
      description: "\"For the word of God is living and powerful, sharper than any two-edged sword.\" Experience the transforming power of Scripture that pierces the heart and reveals God's truth.",
      videoUrl: "https://customer-assets.emergentagent.com/job_faith-library-22/artifacts/7qcrxt5f_FB_VID_2865568817778559371.mp4",
      thumbnail: "https://customer-assets.emergentagent.com/job_faith-library-22/artifacts/ujovxucc_Screenshot_2026-06-24-16-54-07-38_f69139cffc4d135a71392e13634f144a.jpg"
    }
  ];

  return (
    <div className="min-h-screen bg-background-primary">
      <Navbar />

      {/* Banner */}
      <section 
        className="relative h-96 flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/13036981/pexels-photo-13036981.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
        data-testid="daily-word-banner"
      >
        <div className="absolute inset-0 bg-brand-primary/85"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 text-center">
          <BookOpen className="h-16 w-16 text-brand-accent mx-auto mb-6" />
          <h1 className="font-heading text-4xl md:text-5xl font-semibold tracking-tighter leading-tight text-white mb-4" data-testid="daily-word-title">
            Daily Word
          </h1>
          <p className="font-body text-lg text-white/90 max-w-2xl mx-auto">
            Fresh biblical teachings to strengthen your faith and deepen your understanding of God's Word
          </p>
        </div>
      </section>

      {/* Video Grid */}
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {videos.map((video) => (
              <div 
                key={video.id}
                className="bg-white border border-slate-200 rounded shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300"
                data-testid={`video-card-${video.id}`}
              >
                {/* Video Player */}
                <div className="aspect-video bg-black">
                  <video
                    controls
                    className="w-full h-full"
                    poster={video.thumbnail}
                    preload="metadata"
                    playsInline
                    data-testid={`video-player-${video.id}`}
                  >
                    <source src={getMediaUrl(video.videoUrl)} type="video/mp4" />
                    Your browser does not support the video element.
                  </video>
                </div>

                {/* Video Info */}
                <div className="p-8">
                  <div className="flex items-center space-x-2 mb-3">
                    <span className="inline-block bg-brand-accent/10 text-brand-accent border border-brand-accent/20 rounded-full px-3 py-1 text-xs font-medium uppercase tracking-wider">
                      {video.scripture}
                    </span>
                  </div>
                  
                  <h3 className="font-heading text-2xl font-medium text-brand-primary mb-4">
                    {video.title}
                  </h3>
                  
                  <p className="font-body text-base leading-relaxed text-slate-700">
                    {video.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-24 md:py-32 bg-background-tertiary">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-medium tracking-tight text-brand-primary mb-6">
            Grow Deeper in God's Word
          </h2>
          <p className="font-body text-lg text-slate-700 mb-8">
            Explore our complete library of biblical resources including audio teachings, written studies, and video content.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/library/audio"
              className="inline-flex items-center justify-center space-x-2 px-6 py-3 bg-brand-accent text-white font-body font-medium rounded hover:bg-brand-accent-hover transition-all duration-300"
            >
              <Play className="h-5 w-5" />
              <span>Browse Audio Library</span>
            </a>
            <a
              href="/library/video"
              className="inline-flex items-center justify-center space-x-2 px-6 py-3 bg-transparent border-2 border-brand-primary text-brand-primary font-body font-medium rounded hover:bg-brand-primary hover:text-white transition-all duration-300"
            >
              <Play className="h-5 w-5" />
              <span>Explore Video Library</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DailyWord;
